import React from "react";
import Breadcrumbs from "components/Common/Breadcrumb";

import {
	Col,
	Row,
	Card,
	CardBody,
} from "reactstrap";

import ServiceRequestsTable from 'components/ServiceRequestsTable/ServiceRequestsTable';

const ServiceRequestsOutstaff = () => {
	document.title = 'Заявки | Archi-crm';

	return (
		<div className="page-content">
			<div className="container-fluid">
				<Breadcrumbs title="Заявки" breadcrumbItem="Список заявок" />
				<Row>
					<Col xs="12">
						<Card>
							<CardBody>
								<ServiceRequestsTable />
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default ServiceRequestsOutstaff;
